// Utility to build srcSet strings for WebP and JPEG from files created by scripts/optimize-images.mjs
// Example basePath: 'optimized/IMG_2862' or 'Fig-Tree-Conservatory-Dining'
// It will generate URLs under `${PUBLIC_URL}/images/optimized/${basePath}-w{width}.webp|.jpg`

// For gallery/thumbs we only need small sizes.
const widths = [480, 768];

export function buildSrcSets(basePath, customWidths) {
  const ws = Array.isArray(customWidths) && customWidths.length ? customWidths : widths;
  const publicBase = `${process.env.PUBLIC_URL || ''}/images/optimized/${basePath}`;
  const srcSetWebp = ws.map(w => `${publicBase}-w${w}.webp ${w}w`).join(', ');
  const srcSetJpg = ws.map(w => `${publicBase}-w${w}.jpg ${w}w`).join(', ');
  return { srcSetWebp, srcSetJpg };
}

export const defaultSizes = '320px';
